<div class="page-content">
  @if (showAddItemForm) {
    <form class="add-item-row" (submit)="onAddItem()">
      <mat-form-field class="full-width no-padding-bottom" appearance="outline">
        <input
          matInput
          placeholder="{{ addItemLabel | i18nextCap }}"
          [formControl]="newItemControl"
        />
      </mat-form-field>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!newItemControl.valid || !newItemControl.dirty"
      >
        {{ 'add' | i18nextCap }}
      </button>
    </form>
  }

  @if (showAddItemForm) {
    <mat-divider></mat-divider>
  }

  <div class="height-limit">
    @for (item of items$ | async; track item; let i = $index) {
      <mat-card class="full-width item-card">
        <mat-card-content class="full-width item-card-content" #cardContent>
          <form
            #f="ngForm"
            (ngSubmit)="onEditItem(item.id, i, f)"
            class="item-card-content-form"
          >
            <div #titleCard [attr.index]="i" class="full-width full-height">
              @if (i == editingNameIndex) {
                <div>
                  <mat-form-field
                    class="full-width no-padding no-padding-bottom"
                    appearance="outline"
                  >
                    <input
                      name="name"
                      ngModel
                      matInput
                      [ngModel]="item[titlePropertyName]"
                      class="edit-input"
                    />
                  </mat-form-field>
                </div>
              }
              @if (i != editingNameIndex) {
                <div>
                  {{ item[titlePropertyName] | i18nextCap }}
                </div>
              }
            </div>
            <div class="options">
              @if (i != editingNameIndex && canEditItemName) {
                <button mat-icon-button (click)="enableEditName(i)">
                  <div class="icon blue-icon">
                    <fa-icon [icon]="faPen"></fa-icon>
                  </div>
                </button>
              }
              @if (i == editingNameIndex) {
                <button mat-icon-button type="submit" #submitEditLossMotive>
                  <div class="icon green-icon">
                    <fa-icon [icon]="faFloppyDisk"></fa-icon>
                  </div>
                </button>
              }
              @if (canDeleteItemName) {
                <button
                  mat-icon-button
                  (click)="onDeleteItem(item.id, i)"
                  type="button"
                >
                  <div class="icon red-icon">
                    <fa-icon [icon]="faTrashCan"></fa-icon>
                  </div>
                </button>
              }
              @if (canToggleItem) {
                <mat-slide-toggle
                  (toggleChange)="onToggleItem(item.id, item.active)"
                  [checked]="item.active"
                ></mat-slide-toggle>
              }
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
